import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="217.11"
      height="314.891"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 217.11 314.891"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-1580.606 -695.609)"
      >
        <path
          strokeWidth="5"
          d="M1670 1008c-4-1-10.96-2.34-20-3-7.84-.57-7.73 2.86-16 1-8.27-1.86-15.33-6.334-17.06-8.45-10.44-12.737-6.82-23.145-8.28-37.898-.28-2.89-.58-6.492-.3-9.361 0 0 .16-6.862.16-10.769.01-7.377-.18-14.918-1.35-22.438-3.34-21.274-14.95-49.957-.91-69.203 0 0 8.5-8.313 12.83-12.382 3.06-2.872 7.11-4.894 8.97-8.946.73-1.595 4.73-6.053 3.85-7.974-1.03-2.234-6.62 4.785-6.92 2.075-.52-4.715 5.7-6.995 7.29-10.469.92-1.992-.95-8.804-.88-8.859 1.12-.849 3.82 1.42 4.44 1.017.31-.198 1.16-5.343 1.16-5.343m116-1c1.79.894-.44 8.343 7.33 14.168 3.32 2.497 1.56-8.964 6.01-4.51 2.17 2.166-.23 6.908 1.69 8.833 1.63 1.625 2.39-1.301 3.76-.752 3.04 1.215.23 5.306 1.69 6.766 1.58 1.578 5.08.501 5.08 4.511 0 1.542-3.45 1.447-3.01 3.195 1.18 4.716 7.67 8.465 10.15 12.592 3.67 6.123 5.44 12.953 8.27 19.545 2.85 6.657.14 11.693-1.13 18.043-2.11 10.538-2.66 21.703-2.84 32.609-.11 6.651 0 12-1.11 19.45"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1606.33 968.798c-3.48-.261-16.61 3.349-18.46 6.443-1.32 2.203.07 4.856-.96 6.577-.77 1.285-5.16 9.183-3.38 10.741 3.81 3.334 6.92-.776 10.72.215.39.103-2.39 4.797-.2 6.108 5.51 3.298 24.95 3.528 25.95 3.118"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1622.78 941.196c5.07-10.14 10.9-23.304 10.9-34.86"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1651.86 998.995c7.56-10.275 4.14-46.995 3.83-55.091"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1656.85 978.371c1.17.846 16.54 1.488 17.14.656"
          opacity="1"
        ></path>
        <path
          strokeWidth="2.5"
          d="M1677.2 705.6c-8.4 2.8-15.63 7.233-21.7 13.3-6.07 6.067-10.5 13.067-13.3 21-2.8 7.933-3.97 16.1-3.5 24.5.47 8.4 0 14-1.4 16.8-1.4 2.8-1.17 7 .7 12.6 1.87 5.6 4.43 9.1 7.7 10.5 3.27 1.4 7 4.667 11.2 9.8 4.2 5.133 8.4 8.633 12.6 10.5 4.2 1.867 6.53 3.733 7 5.6.47 1.867 1.63 3.267 3.5 4.2 1.87.933 5.13 1.633 9.8 2.1 4.67.467 7.7 0 9.1-1.4 1.4-1.4 2.1-3.267 2.1-5.6 0-2.333-.7-4.2-2.1-5.6-1.4-1.4-4.2-2.567-8.4-3.5-4.2-.933-8.17-.933-11.9 0-3.73.933-8.17-.7-13.3-4.9-5.13-4.2-7.23-7-6.3-8.4.93-1.4 2.57-1.867 4.9-1.4 2.33.467 3.97-.467 4.9-2.8.93-2.333-.23-8.167-3.5-17.5s-5.37-14.467-6.3-15.4c-.93-.933-3.03-1.167-6.3-.7l-4.9.7v-10.5c0-7 1.17-13.533 3.5-19.6 2.33-6.067 4.9-10.733 7.7-14 2.8-3.267 7.7-6.533 14.7-9.8 7-3.267 14.47-4.9 22.4-4.9 7.93 0 15.17 1.633 21.7 4.9 6.53 3.267 11.2 6.533 14 9.8 2.8 3.267 5.37 7.7 7.7 13.3 2.33 5.6 3.5 12.367 3.5 20.3v11.9l-2.1-1.4c-1.4-.933-3.27-1.167-5.6-.7-2.33.467-5.37 5.833-9.1 16.1-3.73 10.267-5.13 16.333-4.2 18.2.93 1.867 4.2 3.033 9.8 3.5 5.6.467 9.57.233 11.9-.7 2.33-.933 4.9-5.133 7.7-12.6s3.5-12.133 2.1-14c-1.4-1.867-2.1-8.4-2.1-19.6 0-11.2-2.33-21-7-29.4-4.67-8.4-10.73-14.933-18.2-19.6-7.47-4.667-15.4-7.467-23.8-8.4-8.4-.933-16.8 0-25.2 2.8z"
          opacity="1"
        ></path>
        <path
          strokeWidth="2.5"
          d="M1737 720c-3.37-9.256-18-21.5-37-23s-34.25 9.381-40 18"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1764 869s-9.75 25.25-15 40-6 19-6 19"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1725.55 807.105c-.45 4-.9 8.836-7.7 16.581C1710.73 831.799 1708 837 1699 841c-9 4-15-3-15-3"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;